export default "__VITE_ASSET__CEsK_Bjh__"